import { Box, Flex, FormLabel, Tooltip } from '@chakra-ui/react';
import { IconCircleInfo } from 'central-icons/IconCircleInfo';
import type { ReactNode } from 'react';

import { Badge } from '@revelio/ui';

export const PreferenceEditorSectionHeading = ({
  title,
  tooltip,
  indicateDiff,
}: {
  title: string;
  tooltip?: ReactNode;
  indicateDiff: boolean;
}) => {
  return (
    <Box width="full" mb={1}>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center" color="text.primary" gap={1}>
          <FormLabel fontSize="sm" fontWeight="semibold" mb={0} mr={0}>
            {title}
          </FormLabel>
          {tooltip && (
            <Tooltip
              label={tooltip}
              padding="8px 12px"
              borderRadius="4px"
              bg="#2d426a"
              placement="right"
              hasArrow
              maxW="227px"
            >
              <Box>
                <IconCircleInfo size={16} cursor="pointer" />
              </Box>
            </Tooltip>
          )}
        </Flex>

        {indicateDiff && (
          <Box mx={1}>
            <Badge size="sm" />
          </Box>
        )}
      </Flex>
    </Box>
  );
};
